import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full h-full flex items-center justify-center"
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_ctx.imageUrl === undefined)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_icon, { class: "is-loading" }, {
          default: _withCtx(() => [
            _createVNode(_component_Loading)
          ]),
          _: 1
        })
      ]))
    : (_ctx.imageUrl)
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _ctx.imageUrl
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true)
}